import type {
  ElementScroll,
  ElementSize,
  GetSlideProps,
} from "./gallery-modal.type";
import type { GalleryItem } from "../gallery.type";
import type { CSSProperties } from "react";

import { GALLERY_MODAL_GUTTER } from "./gallery-modal.constant";

export const getGalleryModalTitle = (item?: GalleryItem): string => {
  if (!item) return "";

  const title = item.title;

  if (!item.description) return title;

  return `${title} - ${item.description}`;
};

export const getSlideSize = ({
  zoom,
  containerSize,
}: GetSlideProps): ElementSize => {
  const gutter = GALLERY_MODAL_GUTTER;

  const width = (containerSize.width - gutter.X * 2) * zoom;
  const height = (containerSize.height - gutter.Y * 2) * zoom;

  return {
    width: containerSize.width === 0 ? 0 : width,
    height: containerSize.height === 0 ? 0 : height,
  };
};

export const getSlideStyle = ({
  zoom,
  containerSize,
}: GetSlideProps): CSSProperties => {
  const slideSize = getSlideSize({ zoom, containerSize });

  const marginTop = (containerSize.height - slideSize.height) / 2;
  const marginLeft = (containerSize.width - slideSize.width) / 2;

  return {
    width: `${slideSize.width}px`,
    height: `${slideSize.height}px`,
    marginTop: marginTop > 0 ? `${marginTop}px` : undefined,
    marginLeft: marginLeft > 0 ? `${marginLeft}px` : undefined,
  };
};

export const getContainerScroll = ({
  zoom,
  containerSize,
}: GetSlideProps): ElementScroll => {
  const slideSize = getSlideSize({ zoom, containerSize });

  const top = (slideSize.height - containerSize.height) / 2;
  const left = (slideSize.width - containerSize.width) / 2;

  return { top, left };
};
